module.exports = __webpack_public_path__ + "img/no-history.1a447e33.svg";